import { Action } from '../../shared/models/action.model';
import { updateAction } from '../../utils/utility';
import actionsTypes from '../types/blogsTypes';

export const setCurrentLevel = (level: number): Action<any> =>
  updateAction(actionsTypes.SET_CURRENT_LEVEL, level);

export const setSelectedModule = (currModule: any): Action<any> =>
  updateAction(actionsTypes.SET_CURRENT_MODULE, currModule);

export const selectSubModule = (selection: any): Action<any> =>
  updateAction(actionsTypes.SELECT_SUB_MODULE, selection);

export const resetToDefault = (): Action<void> =>
  updateAction(actionsTypes.RESET_DEFAULT);

export const setArticleList = (alist: any[]): Action<any> =>
  updateAction(actionsTypes.SET_ARTICLE_LIST, alist);

export const fetchBlogsFromServer = (): Action<void> =>
  updateAction(actionsTypes.FETCH_BLOGS_SERVER);

export const setBlogs = (blogs: any): Action<any> =>
  updateAction(actionsTypes.SET_BLOGS_FROM_SERVER, blogs);
